<template>
    <div class="contact-form-section section-space--ptb_120" id="contact">
      <b-alert
          v-if="sent"
          :show="dismissCountDown"
          dismissible
          variant="warning"
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged"
      >
        This alert will dismiss after {{ dismissCountDown }} seconds...
      </b-alert>
        <div class="container">
            <div class="row">
                <div class="col-lg-7 order-2 order-lg-1">
                    <div class="section-title text-left section-space--mb_30">
                        <h2 class="font-weight--bold mb-15 wow move-up">
                          Contactez-nous pour tous vos soins podiatriques !
                        </h2>
                        <span class="section-text_left wow move-up" style="color: black">
                          Réservez votre rendez-vous dès maintenant et vivez l'expérience de la clinique
                          podiatrique Pied Pro de Laval.
                        </span>
                    </div>
                    <div class="contact-from-wrapper wow move-up">
                        <form role="form" id="contact-form" method="post">
                            <div class="contact-page-form">
                                <div class="row contact-input">
                                    <div class="col-6 contact-inner">
                                        <input v-model="form.fullName"
                                               name="con_name"
                                               type="text"
                                               placeholder="Votre nom *">
                                    </div>
                                    <div class="col-6 contact-inner">
                                        <input v-model="form.email"
                                               name="con_email"
                                               type="email"
                                               placeholder="Votre courriel *">
                                        <slot name="helpBlock" v-if="!isValidEmail(form.email)">
                                            <div class="text-danger invalid-feedback mt-2" style="display: block;">
                                                Ce format de courriel est invalide.
                                            </div>
                                        </slot>
                                    </div>
                                </div>
                                <div class="contact-inner">
                                    <input v-model="form.phone"
                                           name="con_subject"
                                           type="text"
                                           placeholder="Votre numéro de téléphone *">
                                    <slot name="helpBlock" v-if="!isValidPhone(form.phone)">
                                        <div class="text-danger invalid-feedback mt-2" style="display: block;">
                                          Numéro de téléphone invalid. Doit contenir au minimum 7 chiffres.
                                        </div>
                                    </slot>
                                </div>
                                <div class="contact-inner contact-message">
                                    <textarea v-model="form.message"
                                              name="con_message"
                                              placeholder="Votre message *">
                                    </textarea>
                                    <slot name="helpBlock" v-if="!isValidMessage(form.message)">
                                        <div class="text-danger invalid-feedback mt-2" style="display: block;">
                                           Le message doit etre moins de 500 characteres.
                                        </div>
                                    </slot>
                                </div>
                                <div class="contact-submit-btn">
                                    <button @click="sendEmail" class="ht-btn ht-btn-md" type="submit">Envoyer</button>
                                    <p class="form-messege"></p>
                                </div>
                                <slot name="helpBlock" v-if="!isValidForm()">
                                  <div class="text-danger invalid-feedback mt-2" style="display: block;">
                                    *: Tous ces champs sont requis pour envoyer votre demande au centre Podiatrique Pied Pro de Laval.
                                  </div>
                                </slot>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-lg-5 order-1 order-lg-2">
                    <div class="peatures_image-wrap section-space--mb_40">
<!--                        <div class="row ">-->
<!--                            <div class="col-3 text-right">-->
<!--                                <span>-->
<!--                                    <img src="../../assets/img/dentist-logo/Location-noBackground.png"-->
<!--                                         class="img-fluid"-->
<!--                                         alt="Dentiste Location icon"-->
<!--                                         style="width: 60px; height: 60px; margin-left: 70px;">-->
<!--                                </span>-->
<!--                            </div>-->
<!--                            <div class="col-9">-->
<!--                              660, Chemin Saint-Jean <br>-->
<!--                              La Prairie (Québec)  J5R 2L3-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="image text-center wow move-up">
<!--                            <img class="img-fluid" src="../../assets/img/features/aeroland-contact-form-image-01.png" alt="contact thumb">-->
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2793.1686917698275!2d-73.74024838443914!3d45.56704617910222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc923cef87a0ab7%3A0x1d3cdc14e52b45f!2s1875%20Rue%20Maurice-Gauvin%20Suite%20204%2C%20Laval%2C%20QC%20H7S%202M5!5e0!3m2!1sen!2sca!4v1643094921106!5m2!1sen!2sca"
                                    width="350"
                                    height="350"
                                    style="border:0;"
                                    allowfullscreen=""
                                    loading="lazy">
                            </iframe>
                        </div>
                        <div class="text-center wow move-up" style="color: black">
                          <h5>Heures d’ouverture</h5>
                          Lundi: 9 h à 17 h <br>
                          Mardi: 9 h à 17 h<br>
                          Mercredi: 9 h à 17 h<br>
                          Jeudi: 9 h à 17 h<br>
                          Vendredi: 9 h à 17 h<br>
                          Samedi: Fermé<br>
                          Dimanche: Fermé<br><br>
                        </div>

                    </div>
                </div>
            </div>
          <div class="row">
            <h5>Protection des données personnelles</h5>
            <p style="color: black">
              En conformité avec la Loi sur la protection des renseignements personnels dans le secteur
              privé (LPRP), Dre Rita El-Khoury, podiatre est désignée responsable de la protection
              des renseignements personnels.
              En tout temps, il est possible de contacter Dre El-Khoury à l’aide des
              coordonnées suivantes:
              <br>
              <a href="tel:(579)640-7333" class="hover-style-link" style="font-size: 15px;">
                <i class="fas fa-phone-volume"></i>
                (579) 640-7333
              </a>
              <br>

              <a href="mailto:info@piedpro.ca" class="hover-style-link" style="font-size: 15px;">
                <i class="fas fa-envelope"></i>
                info@piedpro.ca
              </a>
            </p>
            <b-link v-b-modal.modal-1 class="hover-style-link" style="color: #123170">
              Cliquez ici pour en savoir plus
            </b-link>

          </div>
        </div>


      <b-modal id="modal-1"
               scrollable
               hide-footer
               title="Politique de protection des informations personnelles">
        <p class="my-4">
          <b style="color: #123170">Notre engagement en matière de protection de la vie privée</b>
          <br>
          <br>
          Nous accordons une grande importance à la protection de la vie privée des visiteurs de notre site web et nous nous engageons fermement à la protéger, conformément aux lois applicables, y compris la Loi sur la protection des renseignements personnels dans le secteur privé.
          <br>
          <br>
          <b style="color: #123170">Champ d’application de la politique</b>
          <br>
          <br>
          La présente politique de protection des renseignements personnels (ci-après la ” politique “) s’applique à Medi-Club physio. Medi-Club Physio, propriétaire du nom et de la marque de commerce Medi-Club Physio, ainsi que les cliniques Medi-Club Physio et de médecine sportive. Dans la présente politique, ces entités sont désignées collectivement par le terme “nous”.
          <br>
          <br>
          <b style="color: #123170">Vue d’ensemble</b>
          <br>
          <br>
          La présente politique énonce nos principes et nos lignes directrices en matière de collecte, d’utilisation, de divulgation et de conservation des renseignements personnels. En outre, elle décrit les mesures employées pour protéger vos informations personnelles et élucide vos droits d’accès à ces informations. Veuillez noter que les informations personnelles collectées hors ligne peuvent également être régies par des dispositions contractuelles.
          <br>
          <br>
          La collecte d’informations personnelles et ses finalités
          <br>
          <br>
          Les informations personnelles se caractérisent par toute information relative à un individu qui permet de l’identifier.
          <br>
          <br>
          Lorsque vous visitez notre site web, vous avez le choix de le parcourir sans révéler d’informations
          <br>
          <br>
          personnelles. Dans ce cas, notre serveur web enregistre exclusivement votre adresse IP à des fins statistiques. Il s’agit notamment d’évaluer les tendances en matière d’utilisation du site web, de calculer la durée moyenne des visites, de compiler des statistiques sur les utilisateurs, d’identifier les pages web consultées et d’évaluer les performances globales du site.
          <br>
          <br>
          Les seules informations personnelles que nous recueillons sont celles que vous nous fournissez volontairement, soit par le biais de formulaires en ligne pour nous contacter ou vous abonner à nos bulletins d’information, soit par une communication hors ligne dans le cadre d’une relation commerciale entre vous et nous.
          <br>
          <br>
          Ces informations sont collectées aux fins suivantes :
          <br>
          <br>
          Gérer les abonnements aux lettres d’information, faciliter une communication efficace et promouvoir nos produits et services.
          Gérer vos dossiers médicaux et maintenir notre relation contractuelle avec vous, notamment en votre qualité de professionnels de la santé.
          <br>
          <br>
          En outre, nous utilisons des fichiers journaux, communément appelés “cookies”, sur notre site web. Les cookies sont des fichiers d’information stockés par votre navigateur web sur votre appareil (ordinateur ou téléphone portable). Les cookies servent à diverses fins, notamment à vous reconnaître en tant que visiteur du site web, à suivre l’ordre dans lequel vous accédez aux différentes pages du site, à améliorer la fonctionnalité du site, à répondre aux besoins d’information de nos visiteurs, à identifier et à cibler les visiteurs qui manifestent de l’intérêt pour des pages spécifiques du site.
          <br>
          <br>
          Veuillez noter que les cookies ne stockent pas d’informations personnelles, mais qu’ils peuvent améliorer votre expérience de navigation en la personnalisant en fonction de vos interactions avec notre clinique et les membres de notre équipe. En outre, ils permettent de présenter des publicités de Medi-club sur d’autres sites web visités par les utilisateurs de notre site web. Vous avez la possibilité de configurer les paramètres de votre navigateur pour recevoir des notifications lorsqu’un fichier cookie est reçu et pour accorder ou refuser la permission de stocker des cookies sur votre appareil.
          <br>
          <br>
          <b style="color: #123170">Consentement</b>
          <br>
          <br>
          Nous demandons votre consentement explicite lorsque nous recueillons des informations vous concernant, en veillant à ce que leur utilisation soit conforme aux objectifs spécifiés mentionnés plus haut. Nous devons obligatoirement obtenir votre consentement avant d’utiliser vos informations à d’autres fins ou de collecter des données supplémentaires à votre sujet. Vous conservez le droit de retirer votre consentement, bien que cela soit soumis à des contraintes légales ou contractuelles.
          <br>
          <br>
          Dans certaines circonstances, une obligation légale ou de sécurité peut nous contraindre à collecter, utiliser ou divulguer vos informations personnelles. Cela se produit généralement lorsque la collecte de données est essentielle pour enquêter sur des violations de contrats ou de lois, pour identifier des activités frauduleuses ou des comportements criminels, ou pour faire appliquer les lois en vigueur. Dans de telles situations, le fait de demander votre consentement peut entraver la réalisation des objectifs visés par la collecte de ces informations.
          <br>
          <br>
          <b style="color: #123170">Limites et mesures de sécurité</b>
          <br>
          <br>
          Notre collecte de données se limite aux informations essentielles aux fins énoncées. Nous collectons directement vos informations personnelles, sauf si vous avez donné votre accord pour la collecte de données par des tiers ou si cette collecte est légalement autorisée. Nous ne sommes pas autorisés à divulguer vos informations personnelles à des tiers sans votre consentement, sauf si la loi l’exige.
          <br>
          <br>
          Seules les personnes disposant de l’autorisation appropriée et ayant besoin de vos informations personnelles dans le cadre de leurs responsabilités professionnelles peuvent y accéder. Nous collaborons avec des prestataires de services et des partenaires tiers chargés de la maintenance du site web, du développement d’applications, de l’hébergement et d’autres services connexes. Ces parties externes ne reçoivent que les informations essentielles à l’accomplissement de leurs tâches. Nos accords avec ces prestataires de services les obligent à respecter la confidentialité de vos données et à se conformer aux lois régissant la protection des informations personnelles.
          <br>
          <br>
          <b style="color: #123170">Période de conservation</b>
          <br>
          <br>
          Nous conservons vos informations personnelles pendant la période spécifique nécessaire à la réalisation de l’objectif visé, après quoi nous veillons à leur suppression sécurisée et permanente. Tout au long du processus de destruction des données, nous appliquons des mesures strictes pour empêcher tout accès non autorisé.
          <br>
          <br>
          <b style="color: #123170">Mesures de sécurité</b>
          <br>
          <br>
          Nous avons mis en place des protocoles de sécurité rigoureux pour assurer la confidentialité des informations personnelles que vous nous confiez, en les protégeant des risques potentiels tels que la perte, le vol, l’accès non autorisé, la divulgation, la copie, l’utilisation ou l’altération. Cependant, il est important de reconnaître qu’aucune méthode de transmission de données sur Internet ou de stockage électronique ne peut fournir une garantie absolue de sécurité à 100 %. Par conséquent, nous ne pouvons pas vous assurer que vos informations ne seront pas consultées, acquises, divulguées, modifiées ou compromises à la suite d’éventuelles violations de nos physiques, techniques ou administratives. Toute transmission d’informations à notre intention se fait à votre discrétion et à vos risques et périls.
          <br>
          <br>
          <b style="color: #123170">Droits des propriétaires d’informations personnelles :</b>
          <br>
          <br>
          En vertu des lois applicables en matière de protection des données, les individus possèdent des droits spécifiques, notamment :
          <br>
          <br>
          Accès/portabilité : Vous avez le droit de vous enquérir de l’existence de vos informations personnelles en notre possession. Le cas échéant, vous pouvez demander l’accès à ces informations, ce qui vous permettra de vérifier les données que nous détenons et de comprendre l’usage qui en est fait.
          <br>
          Exactitude : Nous sommes tenus de veiller à ce que les informations personnelles en notre possession soient exactes, complètes, non trompeuses et à jour.
          <br>
          Rectification : Vous avez le droit de demander la correction des informations personnelles incomplètes ou inexactes que nous détenons.
          <br>
          Consentement : Bien que nous recueillions et utilisions les informations personnelles avec un consentement éclairé, vous conservez le droit de retirer votre consentement à la communication ou à l’utilisation des informations à tout moment.
          <br>
          Effacement : dans certaines circonstances, vous pouvez demander l’effacement, la destruction, l’anonymisation, la désindexation ou le retrait de vos informations personnelles. Ces circonstances peuvent inclure des données qui ne sont plus nécessaires à leur finalité initiale ou au retrait du consentement. Nous traitons ces demandes conformément aux lois applicables en matière de protection des données.
          <br>
          <br>
          <b style="color: #123170">Demandes de renseignements et plaintes</b>
          <br>
          <br>
          Nous nous engageons à répondre à vos demandes et à examiner minutieusement toute plainte concernant vos informations personnelles.
          <br>
          <br>
          <b style="color: #123170">Modifications de la politique</b>
          <br>
          <br>
          Nous nous réservons le droit de modifier la présente politique. Toute modification sera mise à jour sur notre site web, accompagnée d’un avis de modification. L’utilisation de notre site après la publication d’un tel avis constitue votre consentement à ces modifications.
        </p>
      </b-modal>

      <!-- MODAL -->
        <b-modal id="modal-RDZ-contact" class="modal-backdrop" size="xl" title="Réservez votre prochaine date approximative souhaitée."
                 :hide-footer="true" v-model="sent">
          <b-alert
              show
              dismissible
              variant="success"
          >
            Votre message a ete envoyer avec success! Notre receptioniste vous appelera dans un delais de 24h.
            <br>
            Merci.
          </b-alert>
        </b-modal>

    </div>
</template>

<script>
    const querystring = require("querystring");
    export default {
        name: 'ContactFormPiedPro',
        data() {
          return {
            form: {
              fullName: '',
              email: '',
              phone: '',
              message: '',
              smsChecked: 'NON'
            },
            value: '',
            sent: false,
            protectionDetails: false,
            dismissSecs: 5,
            dismissCountDown: 0
          }
        },
        methods: {
          sendEmail(e) {
            // debugger
            if(this.isValidForm)
            {
              // // eslint-disable-next-line no-console
              // console.log(e)
              // this.sent = true;
              e.preventDefault();
              this.$axios
                  .post(
                      "https://piedpro.ca/mail.php",
                      querystring.stringify(this.form)
                      // {headers:{"Content-Type" : "application/x-www-form-urlencoded"}}
                  )
                  .then(res => {
                    // eslint-disable-next-line no-console
                    console.log(res);
                    this.sent = true;
                  })
                  .catch(function (error) {
                    if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      // eslint-disable-next-line no-console
                      console.log(error.response.data);
                      // eslint-disable-next-line no-console
                      console.log(error.response.status);
                      // eslint-disable-next-line no-console
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      // eslint-disable-next-line no-console
                      console.log(error.request);
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      // eslint-disable-next-line no-console
                      console.log('Error', error.message);
                    }
                    // eslint-disable-next-line no-console
                    console.log(error.config);
                  });
            }
          },
          isValidEmail(email) {
            const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
          },
          isValidPhone(phone) {
            const re = /^$|^(\+?\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
            return re.test(String(phone).toLocaleLowerCase())
          },
          isValidMessage(message) {
            const re = /^(.{0,100})$/;
            return re.test(String(message).toLocaleLowerCase())
          },
          isValidForm() {
            // if(this.form.email && this.form.fullName && this.form.message && this.form.phone) {
            if(this.isValidEmail(this.form.email)
                && this.isValidMessage(this.form.message)
                && this.isValidEmail(this.form.phone)
                && this.form.fullName != ''
                && this.form.email    != ''
                && this.form.message  != '' ) {
              return true
            }
            else {
              return false
            }
          },
          countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
          },
          showAlert() {
            this.dismissCountDown = this.dismissSecs
          }
        }
    }
</script>